// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

const initialState = fromJS({
  bulkEditBandOptions: [],
  bulkEditPaths: [],
  highlightedPathIds: [],
  highlightedSiteIds: [],
  modalConfig: null,
  sortAsc: true,
  sortCol: 'pathIndex',
  unitType: 'SI',
  visiblePathIds: [],
})

export default initialState
